import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appHighlightCallScriptFields]'
})
export class HighlightCallScriptFieldsDirective {
  @Input() fieldName: string;
  @Input() linkedFieldsList: any[] = [];

  constructor(private elementRef: ElementRef,
    private renderer: Renderer2) { }

  ngDoCheck() {
    this.highlightField();
  }

  private highlightField() {
    const shouldHighlight = this.checkFieldInArray(this.fieldName, this.linkedFieldsList);
    if (shouldHighlight) {
      this.renderer.addClass(this.elementRef.nativeElement, 'highlightField');
    } else {
      this.renderer.removeClass(this.elementRef.nativeElement, 'highlightField');
    }
  }

  private checkFieldInArray(fieldName: string, fields: any[]): boolean {
    const findObj = fields && fields.length ? fields.find((ele) => ele.sectionPropertyName === fieldName) : null;
    return !!findObj;
  }
}
